module.exports = __webpack_public_path__ + "img/Pista_1836.87a964b7.png";